<template>
    <answers ref="answers"
             code_question_group="GQ02"
             danger_code="MCAL23"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
